export const version = "rlp/5.5.0";
//# sourceMappingURL=_version.js.map